import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AngularFireModule } from "@angular/fire/compat";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { NgxsModule } from "@ngxs/store";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { UserState } from "./states/user.state";
import { NgxsRouterPluginModule } from "@ngxs/router-plugin";
import { ServiceWorkerModule } from "@angular/service-worker";
import { LocationService } from "./services/location.service";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { GraphQLModule } from "./apollo-clients-module";
import { ApiService } from "./services/api.service";
import { AngularFirePerformanceModule } from "@angular/fire/compat/performance";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { UIState } from "./states/ui.state";
import { ProductsState } from "./states/product.state";
import { PlacesState } from "./states/places.state";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatBadgeModule } from "@angular/material/badge";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { BasicModule } from "./helpers/basic.module";
import { ComponentsModule } from "./components/components.module";
import {
  AngularFireAnalyticsModule,
  ScreenTrackingService,
  UserTrackingService,
} from "@angular/fire/compat/analytics";
import { UserDeviceState } from "./states/device.state";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ApolloModule } from "apollo-angular";
import { MiniCartComponent } from "./pages/cart/mini-cart/mini-cart.component";
import { MatCardModule } from "@angular/material/card";
import { FormsModule } from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { provideFirestore, getFirestore } from "@angular/fire/firestore";
import { provideStorage, getStorage } from "@angular/fire/storage";
import { LoadingComponent } from "./helpers/basic/loading/loading.component";
@NgModule({
  declarations: [AppComponent, MiniCartComponent, LoadingComponent],

  imports: [
    BrowserModule,
    MatCheckboxModule,
    GraphQLModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    NgxsModule.forRoot([
      UserState,
      ProductsState,
      UIState,
      PlacesState,
      UserDeviceState,
    ]),
    NgxsRouterPluginModule.forRoot(),
    NgxsLoggerPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    AngularFirePerformanceModule,
    AngularFireMessagingModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCardModule,
    BasicModule,
    ComponentsModule,
    ApolloModule,
    FormsModule,
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    ApiService,
    LocationService,
    ScreenTrackingService,
    UserTrackingService,
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
